import "reflect-metadata";
import { Container } from "inversify";

export const container = new Container({ defaultScope: "Singleton" });
export const AppVersion = Symbol("appVersion");
export const AppName = Symbol("appName");
export const FetchMethod = Symbol("fetchMethod");
export const FetchFormData = Symbol("FetchFormData");
